// extracted by mini-css-extract-plugin
var _1 = "SidebarMenuItem-module__sectionName--Sa9qw";
export { _1 as "sectionName" }
